/**
 * Le scalaire `GraphQLDate` arrive en millisecondes (cf. `scalars.GraphQLDate: 'number'` du codegen),
 * pas en ISO : tout passe par ces helpers pour ne pas réinventer le parsing à chaque affichage.
 */
export function formatHour(timestamp: number): string {
    const date = new Date(timestamp);

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}h${minutes}`;
}

/** « entre 7h45 et 10h00 », « à partir de 7h45 », « avant 10h00 » — ou rien si les deux bornes manquent. */
export function formatHourRange(start?: number | null, end?: number | null): string | null {
    if (start && end) {
        return `entre ${formatHour(start)} et ${formatHour(end)}`;
    }

    if (start) {
        return `à partir de ${formatHour(start)}`;
    }

    if (end) {
        return `avant ${formatHour(end)}`;
    }

    return null;
}

/** « vendredi 18 septembre 2026 » — le format de la page transporteur qu'on remplace. */
export function formatLongDateFR(birthdayDate: string): string {
    const [year, month, day] = birthdayDate.split('-').map(Number);
    if (!year || !month || !day) {
        return '';
    }

    return new Intl.DateTimeFormat('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(new Date(year, month - 1, day));
}

/** Initiales pour la pastille du livreur : « Yannick Martin » → « YM ». */
export function initialsOf(name: string): string {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? '')
        .join('');
}
